import React from "react"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import images from "assets/images"

const UserCard = (props: any) => {
  const { user, onEdit } = props

  return (
    <React.Fragment>
      <Col xl="3" sm="6">
        <Card className="text-center">
          <CardBody>
            {!user.img ? (
              <div className="avatar-sm mx-auto mb-4">
                <span
                  className={
                    "avatar-title rounded-circle bg-soft-" +
                    user.color +
                    " text-" +
                    user.color +
                    " font-size-16"
                  }
                >
                  {user.name.charAt(0)}
                </span>
              </div>
            ) : (
              <div className="mb-4">
                <img
                  className="rounded-circle avatar-sm"
                  src={images[user.img]}
                  alt=""
                />
              </div>
            )}

            <h5 className="font-size-15">
              <Link to="#" className="text-dark">
                {user.name}
              </Link>
            </h5>
            <p className="text-muted">{user.email}</p>
            <p className="text-muted">Password: {user.visiblePwd}</p>
            <p className="text-muted">Role: {user.role}</p>
            {/* <div>
              {user.skills.map((skill, key) => (
                <Link
                  to="#"
                  className="badge badge-primary font-size-11 m-1"
                  key={"_skill_" + key}
                >
                  {skill.name}
                </Link>
              ))}
            </div> */}
          </CardBody>
          <CardFooter className="bg-transparent border-top">
            <div className="contact-links d-flex font-size-20">
              <div className="flex-fill">
                <i onClick={e => onEdit()} style={{cursor: 'pointer'}} className="bx bx-edit-alt" />
              </div>
            </div>
          </CardFooter>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default UserCard
